import axios from 'axios';
//vant 弹框
import Dialog from 'vant/lib/dialog';
import {
    domain
} from './api_config.js';

// 配置默认域名，请求接口时自动添加域名
axios.defaults.baseURL = domain;
axios.defaults.headers = {
    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
}, axios.defaults.withCredentials = true;

axios.interceptors.request.use(
    config => {
        return config;
    }, error => {
        console.log(error)
        Promise.reject(error)
    })
axios.interceptors.response.use(
    rsp => {
        let rspinfo = rsp.data;
        if (!rspinfo.success) {
            console.log('axios响应拦截器---请求成功但返回异常');
            console.log(rspinfo.msg);
            
            //登陆已过期，重定向授权
            if (rspinfo.code == "401") {
                // Dialog.alert({
                //     title: '提示',
                //     message: rspinfo.msg
                // }).then(() => {
                //     window.location.href = rspinfo.redirect
                // });
                window.location.href = rspinfo.redirect
                return;
            }
        }
        return rspinfo
    }, 
    err => {
        const { errCode, errMsg } = getErrMsg(err);
        if (errCode == 401) { //登录失效  
            Dialog.alert({
                title: '提示',
                message: errMsg
            }).then(() => {

            });
        } else {
            Dialog.alert({
                title: '提示',
                message: errMsg
            }).then(() => {
            });
        }
        return Promise.reject(err)
    }
)
const ERR_CODE_LIST = { //常见错误码列表
    [400]: "请求错误",
    [401]: "登录失效,请关闭当前页面重新进入",
    [403]: "拒绝访问",
    [404]: "请求地址出错",
    [408]: "请求超时",
    [500]: "服务器内部错误",
    [501]: "服务未实现",
    [502]: "网关错误",
    [503]: "服务不可用",
    [504]: "网关超时",
    [505]: "HTTP版本不受支持"
}
function getErrMsg(error) {//通过error处理错误码
    if (!error.response) {//无网络时单独处理
        //return { errCode: null, errMsg: "网络不可用，请刷新重试" }
    }
    const errCode = error.response.status //错误码
    const errMsg = ERR_CODE_LIST[errCode] //错误消息

    return { errCode: errCode, errMsg: errMsg ? `${errMsg} [${errCode}]` : error.message }
}
export default axios;